<script lang="ts">
  import Close from '~icons/mdi/close';
  import Send from '~icons/mdi/send';
  import ActionButton from '../components/ActionButton.svelte';
  import Modal from '../components/Modal.svelte';
  import Spinner from '../components/Spinner.svelte';
  import { sendFeedbackMutation } from '~/lib/mutations.svelte';
  import { ModalState } from '~/lib/nav.svelte';
  import MailIcon from '~icons/feather/mail';
  import { sessionId } from '~/auth/utils.svelte';
  import { PersistedState } from 'runed';

  const feedbackModal = new ModalState('feedback');
  const openedFeedback = new PersistedState('openedFeedback', false);
  const sendFeedback = sendFeedbackMutation('classic');

  const handleOpen = async () => {
    sendFeedback.reset();
    feedbackModal.push();
    openedFeedback.current = true;
  };

  const handleClose = () => {
    feedbackModal.pop();
  };

  const handleSendFeedback = async (e: SubmitEvent) => {
    const formData = new FormData(e.target as HTMLFormElement);
    await sendFeedback.mutateAsync(formData);
    handleClose();
  };
</script>

<ActionButton
  class={sendFeedback.isSuccess ? 'feedback-submitted' : ''}
  buttonId="feedback"
  onClick={handleOpen}
>
  <MailIcon size="1.5em" />
  Contact
</ActionButton>
<Modal open={feedbackModal.open} index={3} onClose={handleClose}>
  {#snippet title()}
    <MailIcon />
    Leave Feedback
  {/snippet}
  {#snippet content()}
    <p>Tell me which mechanics work and which don't</p>
    <p>Report missing words you think should be included</p>
    <p>
      If you prefer to send an email, I will be able to reply to your message
      directly at
      <a
        class="email"
        href="mailto:support@gramjam.app?subject=Gram Jam Feedback"
        >support@gramjam.app</a
      >
    </p>
    <form
      id="feedback-form"
      class="content"
      on:submit|preventDefault={handleSendFeedback}
    >
      <input type="hidden" name="sessionId" value={sessionId.current} />
      {#if sendFeedback.isPending}
        <Spinner />
      {:else}
        <textarea class="feedback" name="feedback"></textarea>
      {/if}
    </form>
  {/snippet}
  {#snippet controls()}
    <ActionButton onClick={handleClose}>
      <Close />
      Close
    </ActionButton>
    <ActionButton type="submit" form="feedback-form">
      <Send />
      Send
    </ActionButton>
  {/snippet}
</Modal>

<style lang="scss">
  @use '~/theme/themify' as *;
  @use '~/theme/theme';
  :global(#feedback svg) {
    stroke: #ff5252;
  }
  :global(.action.feedback-submitted) {
    @include theme.pulse-animation(theme.$star-bonus);
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #feedback-form {
    width: 100%;
    max-width: 20em;
  }
  .feedback {
    width: 100%;
    min-height: 4em;
  }
  .email {
    text-decoration: underline;
    @include themify {
      color: themed('link');
    }
  }
</style>
